import { useEffect } from 'react';

let currencyContext = 'USD';

export function getCurrencyCode()
{
    return currencyContext;
}

export function formatCurrency(amount) {
    amount = parseFloat(amount);
    if (Number.isNaN(amount)) {
        amount = 0;
    }

    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyContext,
    }).format(amount.toFixed(2));
    //return `\$${parseFloat(amount).toFixed(2)}`;
}

export function getCurrencySymbol() {
    return formatCurrency(0)
        .replaceAll('.', '')
        .replaceAll('0', '')
        .replaceAll(',', '');
}

export function useSetCurrency(currency) {
    if (currency) {
        currencyContext = currency;
    }

    useEffect(() => {
        if (currency) {
            currencyContext = currency;
        }
    }, [currency]);
}
